import type { CustomCellRendererProps } from "@/ui/molecules/Grid";
import clsx from "clsx";

import { Icon, IconBox } from "@proda-ai/ui-kit";

import Box from "@/ui/atoms/Box";
import Badge from "@/ui/atoms/Badge";

type TOptionAccount = {
    label: string;
    value: string | null;
};

export type GridEditChartOfAccountsDropdownItemAccountsProps =
    CustomCellRendererProps & {
        optionsAccountsArray: TOptionAccount[];
        displayRightIcon?: boolean;
    };

export const testIds = {
    main: "GridEditChartOfAccountsDropdownItemAccounts",
    selected: "GridEditChartOfAccountsDropdownItemAccountsWithRightIcon",
    text: "GridEditChartOfAccountsDropdownItemAccounts-text",
};
const GridEditChartOfAccountsDropdownItemAccounts = (
    props: GridEditChartOfAccountsDropdownItemAccountsProps,
) => {
    const { optionsAccountsArray, displayRightIcon } = props;
    const value = props.value as string | null;
    const type = optionsAccountsArray.find(option => option.value === value);
    const severity =
        value === "income"
            ? "success"
            : value === "expense"
              ? "error"
              : value === "non-operating"
                ? "inactive"
                : null;

    const testId = displayRightIcon === true ? testIds.selected : testIds.main;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId])}
            sx={{
                position: "relative",
                width: "100%",
                height: "46px",
                gap: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            {type && severity ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        flexGrow: 0,
                        marginRight: "8px",
                    }}
                >
                    <Badge severity={severity}>
                        <Box
                            component={"span"}
                            sx={{
                                textTransform: "capitalize",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {value === "non-operating"
                                ? "Below the line"
                                : value}
                        </Box>
                    </Badge>
                </Box>
            ) : null}
            {displayRightIcon === true && (
                <Box
                    sx={{
                        flexBasis: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        flexGrow: 0,
                        paddingRight: "8px",
                        fontSize: "12px",
                    }}
                >
                    <IconBox>
                        <Icon
                            icon="caret-down"
                            color={"var(--proda-white-150)"}
                        />
                    </IconBox>
                </Box>
            )}
        </Box>
    );
};

export default GridEditChartOfAccountsDropdownItemAccounts;
